import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WizardService } from '@app/wizard-bar/services/wizard.service';
import { Observable } from 'rxjs';
import { UdFile } from '../UdFile';

@Component({
  selector: 'app-upload-dialog',
  templateUrl: './upload-dialog.component.html',
  styleUrls: ['./upload-dialog.component.scss'],
})
export class UploadDialogComponent implements OnInit {
  public frmUpload: FormGroup;
  public quoteRequestId: number;
  public showErrorText: boolean;
  public documentType: string = 'LoaDocument'; // only used for loa at the moment, replace with an argument passed in if used for another purpose
  public invalidatesQuoteRequest: boolean = false; // loa uploads don't invalidate

  constructor(
    public dialogRef: MatDialogRef<UploadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private wizardService: WizardService
  ) {}

  ngOnInit(): void {
    this.resolveWaitForUploadConfirmation = () => {
      const warningRequired = this.wizardService.resolveExpireQuoteWarningDialog(this.invalidatesQuoteRequest);
      if (warningRequired.required) {
        return warningRequired.dialogRef.afterClosed();
      } else {
        return new Observable<any>((obs) => {
          obs.next(true);
          obs.complete();
        });
      }
    };
  }

  public resolveWaitForUploadConfirmation: () => Observable<boolean>;

  public files: Array<UdFile> = new Array<UdFile>();

  public onCompleteUpload(uploadedFiles) {
    uploadedFiles.forEach((f) => {
      if (f === undefined) {
        return;
      }

      this.files.push(f.data);
    });
    this.showErrorText = false;
  }

  public onDeleteUpload(deleteResults) {
    const index = this.files.findIndex((f) => deleteResults.fileId === f.fileId);
    this.files.splice(index, 1);
  }

  public ok() {
    if (this.files?.length > 0) {
      this.dialogRef.close({
        success: this.files?.length > 0 ?? false,
        files: this.files,
      });
    }
    this.showErrorText = true;
  }
}
